export default __webpack_public_path__ + "images/3B.70c9f26.png";